module.exports = __webpack_public_path__ + "static/media/WaveguideDarkIcon.80c07928.svg";